import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const supportAttachment = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    fileName: z.string().nullable().optional().describe('File Name'),

    mimeType: z.string().nullable().optional().describe('Mime Type'),

    base64Content: z.string().nullable().optional().describe('Base64 Content'),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .disabled()
      .describe('createdAt'),

    createdBy: references('User'),

    createdById: z
      .number()
      .nullable()
      .optional()
      .disabled()
      .presentAs('reference')
      .describe('Foreign key to User'),

    updatedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .disabled()
      .describe('updatedAt'),

    updatedBy: references('User'),

    updatedById: z
      .number()
      .nullable()
      .optional()
      .disabled()
      .presentAs('reference')
      .describe('Foreign key to User'),

    caseId: z.number().hidden().describe('Foreign key to SupportCase'),

    accountId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Account'),

    commentId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to SupportComment'),

    userId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    case: belongsTo('SupportCase'),

    account: references('Account'),

    comment: references('SupportComment'),

    user: references('User'),
  })
  .describe(
    'A file attached to a support case, optionally linked to a specific comment.',
  )
  .as('SupportAttachment');

export { supportAttachment as supportAttachmentSchema };
